module.exports = __webpack_public_path__ + "static/media/opentoklogo.8761864d.png";